import React from "react";
import { FormControl, InputLabel, OutlinedInput, IconButton, Box, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import IconNext from "@material-ui/icons/SkipNext";
import IconPrevious from "@material-ui/icons/SkipPrevious";
import moment from "moment";
import { PeriodType } from "../../util";

const MonthYearSelectorOutlined = ({ date, setDate }) => {
  function onMonthClick(option) {
    switch (option) {
      case "CURRENT":
        setDate(moment().startOf(PeriodType.MONTH));
        break;
      case "PREVIOUS":
        setDate(moment(date).subtract(1, PeriodType.MONTH).startOf(PeriodType.MONTH));
        break;
      case "NEXT":
        setDate(moment(date).add(1, PeriodType.MONTH).startOf(PeriodType.MONTH));
        break;
      default:
        break;
    }
  }
  return (
    <FormControl
      fullWidth
      variant="outlined"
      size="small"
      style={{ position: "relative" }}
    >
      <InputLabel
        shrink
        htmlFor="month-year-input"
      >
        <FormattedMessage id="app.report.monthYear" />
      </InputLabel>
      <OutlinedInput
        id="month-year-input"
        readOnly
        notched
        label={<FormattedMessage id="app.report.monthYear" />}
        startAdornment={
          <IconButton
            onClick={() => onMonthClick("PREVIOUS")}
            aria-label="Mês anterior"
            size="small"
          >
            <IconPrevious />
          </IconButton>
        }
        endAdornment={
          <IconButton
            onClick={() => onMonthClick("NEXT")}
            aria-label="Próximo mês"
            size="small"
          >
            <IconNext />
          </IconButton>
        }
      />
      <Box
        position="absolute"
        top="50%"
        left="50%"
        style={{ transform: "translate(-50%, -50%)", pointerEvents: "none" }}
      >
        <Typography
          variant="subtitle1"
          noWrap
        >
          {date.format("MMM YY").replace(/^./, c => c.toUpperCase())}
        </Typography>
      </Box>
    </FormControl>
  );
};

export default React.memo(MonthYearSelectorOutlined);
